import React, { FC, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { fetchData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddSpaceHeader } from './AddSpaceHeader';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddSpaceAvailability: FC = () => {
    const tmp = sessionStorage.getItem('admin')
    const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''
    let t = Tr()
    const { menuId } = useMenuIdPermissions()

    const location = useLocation();
    const editSpacerentalId = (location.state as any)?.spacerentalId || '';

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
    }
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [spaceRenatalDetails, setSpacerentalDetails] = useState([]);
    const [isAllowDay, setIsAllowDay] = useState("0");
    const [isAllowNight, setIsAllowNight] = useState("0");

    
    // set error state
    const [error, setError] = useState([{
        isAllow: '',
        availableDate: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }


    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (isAllowDay !== "1" && isAllowNight !== "1") {
            errorTmp[0].isAllow = t('At Least One Option Must Be Selected');
            isValid = false;
        }
        setError(errorTmp);
        return isValid;
    }
    // space Details api call
    const spaceDetailsApiCall = async () => {

        var param: any = {
            spacerentalId: String(editSpacerentalId),
        }
        var response: any = await fetchData("vendor/public/spaceDetails", param)

        if (response.status == "200") {
            setSpacerentalDetails(response.data);
            var data = response.data[0];
            setIsAllowDay(data.isAllowDay + '')
            setIsAllowNight(data.isAllowNight + '')

        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        if (editSpacerentalId != "") {
            spaceDetailsApiCall();
        }
    }, [])
    // add space api call
    const addSpaceAvailabilityApi = async () => {
        if (validate()) {
            setDisable(true)
            setLoading(true);
            let param: any = {
                spacerentalId: String(editSpacerentalId),
                isAllowDay: isAllowDay,
                isAllowNight: isAllowNight,
                adminId: adminId,
            }

            var res = await fetchData('vendor/public/addSpaceRentalavailability', param)
            if (res.status == "200") {
                toastsuccessmsg("Space Availability Added Successfully!")
                var data = res.data[0];
                const state = {
                    spacerentalId: editSpacerentalId
                }
                setTimeout(() => {
                    navigate(getEncryptedRoute('../addspacepolicies/', { menuId: menuId }), { state })

                    setDisable(false)
                    setLoading(false);
                }, 1500);
            }
            else {
                toasterrormsg(res.message)
                setDisable(false)
                setLoading(false);
            }
        }

    }

    useEffect(() => {
        if (editSpacerentalId != "") {

            spaceDetailsApiCall();
        }
    }, [])
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editSpacerentalId != "" ? t('Edit Space Availability') : t('Add Space Availability')}</PageTitle>
            <AddSpaceHeader spacerentalId={editSpacerentalId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t("Space Availability")}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        spaceRenatalDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    spaceRenatalDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['rentableSpace']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t("Completion")}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t("Completion")}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            <div className="card-body pt-0">
                                                <div className='row'>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="required fs-4 form-label">{t("Space Availability")}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <div className="row">
                                                            <div className="col-lg-6 my-2">
                                                                <label className="form-check form-check-inline form-check-solid me-5">
                                                                    <input className="form-check-input me-3" type="checkbox" name="isAllowDay" value="1" checked={isAllowDay == "1"} onChange={(e: any) => { setIsAllowDay(e.target.checked ? "1" : "0"); removeError("isAllow"); }} />
                                                                    <span className="form-check-label d-flex flex-column align-items-start">
                                                                        <span className="fw-bold ps-2 fs-6 text-dark">{t("Day")}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div className="col-lg-6 my-2">
                                                                <label className="form-check form-check-inline form-check-solid me-5">
                                                                    <input className="form-check-input me-3" type="checkbox" name="isAllowNight" value="1" checked={isAllowNight == "1"} onChange={(e: any) => { setIsAllowNight(e.target.checked ? "1" : "0"); removeError("isAllow"); }} />
                                                                    <span className="form-check-label d-flex flex-column align-items-start">
                                                                        <span className="fw-bold ps-2 fs-6 text-dark">{t("Night")}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div className='text-danger fw-bold'>{error[0].isAllow}</div>
                                                        </div>
                                                        {/* <!--end::Input--> */}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <Link to={getEncryptedRoute('../viewspacerentals/', { menuId: menuId })} id="kt_ecommerce_add_product_cancel" className="btn btn-light me-5">{t("Cancel")}</Link>

                                <button type="submit" disabled={disable} className="btn btn-primary" onClick={addSpaceAvailabilityApi}>
                                    <span className="indicator-label">{t("Save")}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddSpaceAvailability }
